<template>
  <b-tabs
    vertical
    nav-wrapper-class="sticky-top col-md-3 col-12"
    nav-class="nav-left tabs-style rounded-lg"
    pills
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    v-model="tabIndex"
    v-if="masters_mod.length > 0 || search.length > 0"
  >
    <b-tab :key="`search`" title-link-class="p-0 overflow-hidden rounded-md">
      <template #title>
        <div style="height: 100%; width: 100%; border: none">
          <b-form-input
            v-model="search"
            class="rounded-0 border-0"
            @input="onSearch"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </template>
    </b-tab>

    <b-tab
      v-if="search.length > 0 && mastersList.length === 0"
      key="not-available-tab"
      title-link-class="border-0 shadow-sm"
      disabled
    >
      <template #title>
        <span class="text-muted">Not available</span>
      </template>
    </b-tab>

    <!-- Master Tabs -->
    <b-tab
      v-for="(master, index) in mastersList"
      :key="`tab${index}`"
      title-link-class="border-0 shadow-sm"
    >
      <template #title>
        <feather-icon :icon="master.icon || 'HomeIcon'" />
        <span>{{ master.title }}</span>
      </template>
    </b-tab>

    <!-- Table Content -->
    <master-table v-if="masterInfo" :masterInfo="masterInfo" />
    <div v-if="search.length > 0 && mastersList.length === 0" class="p-4 text-center text-muted">
      No results found for "{{ search }}"
    </div>
  </b-tabs>
</template>



<script>
import {
  BTabs,
  BTab,
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import MasterTable from "./MasterTable.vue";
import { masters } from "./masterHelpers";

export default {
  components: {
    BTabs,
    BTab,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BCardHeader,
    BCardBody,
    vSelect,
    MasterTable,
  },
  data() {
    return {
      search: "",
      tabIndex: 1,
      movieInfoDebouce: null,
      masterInfo: null,
      mastersList: [],
      debounce: null,
      masters_mod: [],
    };
  },
  methods: {
    onSearch(input) {
      if (this.debounce) clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (input) {
          this.mastersList = this.masters_mod.filter((item) => {
            if (!item.lbl_name) return;
            // const lbl_name = item.lbl_name.toLowerCase();
            const title = item.title.toLowerCase();
            const lbl_cat = item.lbl_cat.toLowerCase();
            const search = input.toLowerCase();
            return title.includes(search) || lbl_cat.includes(search);
          });
        } else {
          this.mastersList = this.masters_mod;
        }
      }, 1000);
    },
    getFilteredMasters() {
      console.log(masters, "==> masters loaded");
      this.masters_mod = masters.filter((master) => {
        return master && master.lbl_cat && this.$can('read', master.lbl_cat);
      });
      this.mastersList = this.masters_mod;
      console.log(this.mastersList,"this.mastersList")
      this.masterInfo = this.masters_mod[0] || null;
    },
  },
  watch: {
    tabIndex(newValue, oldValue) {
      if (newValue === 0) return;
      this.masterInfo = this.mastersList[newValue - 1];
    },
  },
  mounted() {
    this.$store.dispatch("user/setUserDetails")
      .then(() => {
        // console.log("User details");
        this.getFilteredMasters();
      })
      .catch((err) => {
        console.error("Failed to set user details:", err);
      });
  },
};
</script>
<style>
/* ::-webkit-scrollbar {
  width: 8px !important;
  background-color: #1f307a;
  border-radius: 5px;
} */
/* ::-webkit-scrollbar:hover {
  background-color: #1f307a;
  border-radius: 5px;
} */
.tabs-style {
  background-color: #fff;
  padding: 5px;
}
</style>
